var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _c("breadcrumb", {
        staticClass: "breadcrumb-container",
        attrs: { id: "breadcrumb-container" },
      }),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.showCompanys
            ? _c(
                "div",
                { staticStyle: { width: "20vw" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.changeCompany },
                      model: {
                        value: _vm.companyInfo.id,
                        callback: function ($$v) {
                          _vm.$set(_vm.companyInfo, "id", $$v)
                        },
                        expression: "companyInfo.id",
                      },
                    },
                    _vm._l(_vm.companyOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label:
                            item.companyInfoNumber + "-" + item.companyInfoName,
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.device !== "mobile"
            ? [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "消息通知",
                      effect: "dark",
                      placement: "bottom",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "right-menu-item hover-effect",
                        on: {
                          click: function ($event) {
                            _vm.dialogVisible = true
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-bell" }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "6px",
                              color: "red",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.unreadNum))]
                        ),
                      ]
                    ),
                  ]
                ),
                _c("search", {
                  staticClass: "right-menu-item",
                  attrs: { id: "header-search" },
                }),
                _c("error-log", {
                  staticClass: "errLog-container right-menu-item hover-effect",
                }),
                _c("screenfull", {
                  staticClass: "right-menu-item hover-effect",
                  attrs: { id: "screenfull" },
                }),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "全局大小",
                      effect: "dark",
                      placement: "bottom",
                    },
                  },
                  [
                    _c("size-select", {
                      staticClass: "right-menu-item hover-effect",
                      attrs: { id: "size-select" },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.showSystem
            ? _c(
                "el-dropdown",
                {
                  staticClass: "avatar-container right-menu-item hover-effect",
                  attrs: { trigger: "click" },
                },
                [
                  _c("div", { staticClass: "avatar-wrapper" }, [
                    _vm._v("切换系统"),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    _vm._l(_vm.systemList, function (item) {
                      return _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              return _vm.goToSystem(item)
                            },
                          },
                        },
                        [
                          _c("el-dropdown-item", [
                            _vm._v(_vm._s(item.systemName)),
                          ]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _c(
                    "el-avatar",
                    { attrs: { size: "medium", src: _vm.avatar } },
                    [
                      _c("img", {
                        attrs: {
                          src: "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/profile/index" } },
                    [_c("el-dropdown-item", [_vm._v("个人中心")])],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.clearCache.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v("清除缓存"),
                      ]),
                    ]
                  ),
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [_c("el-dropdown-item", [_vm._v("首页")])],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v("退出"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("verify-code"),
      _c("verify-reset-password"),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "通知",
            visible: _vm.dialogVisible,
            direction: "rtl",
            size: "300px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-left": "20px" } },
            [
              _c(
                "el-row",
                { staticClass: "search-boxx gz-form-row" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-dropdown",
                        {
                          attrs: { trigger: "click" },
                          on: { command: _vm.getlist },
                        },
                        [
                          _c("span", { staticClass: "el-dropdown-link" }, [
                            _c("i", {
                              staticClass: "el-icon-bell",
                              staticStyle: { "font-size": "24px" },
                            }),
                          ]),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  staticClass: "clearfix",
                                  attrs: { command: "1" },
                                },
                                [_vm._v(" 已读 ")]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  staticClass: "clearfix",
                                  attrs: { command: "0" },
                                },
                                [_vm._v(" 未读 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.changeRead(0)
                            },
                          },
                        },
                        [_vm._v("全部已读")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.list, function (item, index) {
            return _c(
              "div",
              {
                staticStyle: { border: "1px solid #f2f6fc", overflow: "auto" },
                style: item.is ? "background-color: #f2f6fc" : "",
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { margin: "15px" },
                    on: {
                      mouseenter: function ($event) {
                        return _vm.mouseenter(item, index)
                      },
                      mouseleave: function ($event) {
                        return _vm.mouseleave(item, index)
                      },
                    },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 23 } }, [
                          _c("span", [_vm._v(_vm._s(item.title))]),
                        ]),
                        _c("el-col", { attrs: { span: 1 } }, [
                          !item.is && !item.isRead
                            ? _c(
                                "div",
                                { staticStyle: { height: "10px" } },
                                [_c("el-badge", { attrs: { "is-dot": "" } })],
                                1
                              )
                            : _vm._e(),
                          item.is
                            ? _c("div", { staticStyle: { height: "10px" } }, [
                                _c("i", {
                                  staticClass: "el-icon-close",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteMessage(item)
                                    },
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ]),
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "10px",
                                "font-size": "12px",
                                width: "240px",
                                overflow: "hidden",
                                "text-overflow": "ellipsis",
                                "white-space": "nowrap",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.clickTitle(item)
                                },
                              },
                            },
                            [
                              _vm._v(" 消息提示： "),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "bottom-start",
                                    title: "消息提示",
                                    width: "280",
                                    trigger: "hover",
                                    content: item.message,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [_vm._v(_vm._s(item.message))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "消息提示",
            visible: _vm.show,
            width: "22%",
            "before-close": _vm.handleClose,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c("el-row", [
            _c("div", [_c("span", [_vm._v(_vm._s(_vm.message))])]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }